const DollarIcon = function DollarIcon() {
  return (
    <svg
      className="fin-state"
      width="25px"
      height="27px"
      viewBox="0 0 25 27"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      style={{ minWidth: '18px' }}
    >
      <g id="Dev-Ready-prototype" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Company_Financials" transform="translate(-607.000000, -1579.000000)" fill="#424B50" fillRule="nonzero">
          <g id="Group-6" transform="translate(175.000000, 881.000000)">
            <g id="Group-8-Copy" transform="translate(394.364244, 668.000000)">
              <g id="assignment_black_24dp-(1)" transform="translate(38.000000, 30.333333)">
                <path d="M5.33333333,18.6666667 L14.6666667,18.6666667 L14.6666667,21.3333333 L5.33333333,21.3333333 L5.33333333,18.6666667 Z M5.33333333,13.3333333 L18.6666667,13.3333333 L18.6666667,16 L5.33333333,16 L5.33333333,13.3333333 Z M5.33333333,8 L18.6666667,8 L18.6666667,10.6666667 L5.33333333,10.6666667 L5.33333333,8 Z M21.3333333,2.66666667 L15.76,2.66666667 C15.2,1.12 13.7333333,0 12,0 C10.2666667,0 8.8,1.12 8.24,2.66666667 L2.66666667,2.66666667 C2.48,2.66666667 2.30666667,2.68 2.13333333,2.72 C1.61333333,2.82666667 1.14666667,3.09333333 0.786666667,3.45333333 C0.546666667,3.69333333 0.346666667,3.98666667 0.213333333,4.30666667 C0.08,4.61333333 0,4.96 0,5.33333333 L0,24 C0,24.36 0.08,24.72 0.213333333,25.04 C0.346666667,25.36 0.546666667,25.64 0.786666667,25.8933333 C1.14666667,26.2533333 1.61333333,26.52 2.13333333,26.6266667 C2.30666667,26.6533333 2.48,26.6666667 2.66666667,26.6666667 L21.3333333,26.6666667 C22.8,26.6666667 24,25.4666667 24,24 L24,5.33333333 C24,3.86666667 22.8,2.66666667 21.3333333,2.66666667 Z M12,2.33333333 C12.5466667,2.33333333 13,2.78666667 13,3.33333333 C13,3.88 12.5466667,4.33333333 12,4.33333333 C11.4533333,4.33333333 11,3.88 11,3.33333333 C11,2.78666667 11.4533333,2.33333333 12,2.33333333 Z M21.3333333,24 L2.66666667,24 L2.66666667,5.33333333 L21.3333333,5.33333333 L21.3333333,24 Z" id="Shape" />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default DollarIcon;
